import { render, staticRenderFns } from "./TextDesPopper.vue?vue&type=template&id=2e35599d&"
import script from "./TextDesPopper.vue?vue&type=script&lang=js&"
export * from "./TextDesPopper.vue?vue&type=script&lang=js&"
import style0 from "./TextDesPopper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports